import Cookies from 'js-cookie'
import {loginMethod} from "@/api/login/loginMethod";
import StorageUtil from "@/utils/StorageUtil";
import store from "@/store";

const TokenKey = 'Admin-Token'
const NameKey = 'Nick-Name'
const TOKEN_KEY = "token"

export function getUser() {
    return store.state.user.user
}

export function getToken() {
    return Cookies.get(TokenKey)
}

export function getTokenSuper() {
    return Cookies.get(TOKEN_KEY)
}


export function setToken(token) {
    StorageUtil.insert(TokenKey,token)
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    Cookies.remove(NameKey)
    StorageUtil.clear()
    return Cookies.remove(TokenKey)
}

export function setNickName(name) {
    return Cookies.set(NameKey, name)
}

export function getNickName() {
    return Cookies.get(NameKey)
}

export function tokenRemove() {
    removeToken()
}

export function logout() {
    removeToken()
    loginMethod.logout().then(res => {
        window.location.href = window.applicationConfig.platformUrl;
    })
}
